import { render } from "./SaleProperty.vue?vue&type=template&id=180e128d&scoped=true"
import script from "./SaleProperty.vue?vue&type=script&lang=js"
export * from "./SaleProperty.vue?vue&type=script&lang=js"

import "./SaleProperty.vue?vue&type=style&index=0&id=180e128d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180e128d"]])

export default __exports__